interface Redirect {
  from: string;
  to: string;
}
export const REDIRECTS: Redirect[] = [
  { from: '/dashboard/simulazione/:id', to: '/simulazioni/:id' },
];

export function resolveRedirect(pathname: string): string | null {
  for (const { from, to } of REDIRECTS) {
    const paramNames: string[] = [];
    const regexStr = from
      .replace(/:[^/]+/g, (m) => { paramNames.push(m.slice(1)); return '([^/]+)'; })
      .replace(/\//g, '\\/');

    const match = new RegExp(`^${regexStr}$`).exec(pathname);
    if (!match) continue;

    return paramNames.reduce(
      (dest, name, i) => dest.replace(`:${name}`, match[i + 1]),
      to,
    );
  }
  return null;
}
